<template>
  <div ref="ro" class="resize-observer"></div>
</template>

<script>
// Нативный ResizeObserver наблюдает за родительским контейнером и эмитит 'notify' при изменении размеров.
export default {
  name: 'ResizeObserver',
  emits: ['notify'],
  mounted() {
    const target = this.$el.parentElement || this.$el;
    this._ro = new ResizeObserver((entries) => {
      const rect = entries[0] && entries[0].contentRect;
      this.$emit('notify', rect ? {width: rect.width, height: rect.height} : undefined);
    });
    this._ro.observe(target);
  },
  beforeUnmount() {
    if (this._ro) {
      this._ro.disconnect();
      this._ro = null;
    }
  },
};
</script>

<style scoped>
.resize-observer {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  pointer-events: none;
  opacity: 0;
}
</style>
